import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';

const ChatModal = ({ modalOpen, setModalOpen,actionLabel }) => {
  const [reason, setReason] = useState('');
  const handleClose = () => setModalOpen(false);

  const handleSubmit = () => {
    handleClose();
  };

  return (
    <Modal open={modalOpen} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography variant="h6" mb={2}>
          Enter Reason
        </Typography>
        <TextField
          label="Reason"
          fullWidth
          multiline
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
        <Box mt={3} display="flex" justifyContent="flex-end" gap={1}>
          {/* <Button onClick={handleClose} color="secondary">
            Cancel
          </Button> */}
          <Button variant="contained" className='gradientButton' onClick={handleSubmit}>
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ChatModal;
